import React, { useState } from 'react';
import { Button, Col, Row } from 'antd';

import { History } from './history';
import { HistoryInfoFragmentFragment } from '@common/graphql/schema';
import { Colors } from '@common/tokens';
import { Divider } from '@common/components/divider';
import { Icon } from '@common/components';

export const HistoryDropDown = ({
  data,
  button = false,
  buttonText,
  hrVisible,
  dropdownText,
}: {
  data: HistoryInfoFragmentFragment[];
  button?: boolean;
  buttonText?: string;
  hrVisible?: boolean;
  dropdownText?: string;
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      {button ? (
        <HistoryDropDownButton
          visible={visible}
          changeDropdown={setVisible}
          buttonText={buttonText}
        />
      ) : (
        <>
          {hrVisible && <Divider fullWidth={false} />}
          <HistoryDropDownLine
            visible={visible}
            changeDropdown={setVisible}
            dropdownText={dropdownText}
          />
        </>
      )}
      {visible && (
        <>
          <History data={data} />
        </>
      )}
    </>
  );
};

const HistoryDropDownLine = ({
  visible,
  dropdownText = 'History',
  changeDropdown,
}: {
  visible: boolean;
  dropdownText?: string;
  changeDropdown: (value: boolean) => void;
}) => (
  <>
    <Row
      className="history-dropdown"
      onClick={() => changeDropdown(!visible)}
      align="middle"
    >
      <Col className="history-dropdown-icon">
        <Icon icon={visible ? 'chevronUp' : 'chevronDown'} kind="regular" />
      </Col>
      <Col className="history-dropdown-title">{dropdownText}</Col>
    </Row>
    <style jsx>{`
      :global(.history-dropdown-title) {
        color: ${Colors.elm};
        font-weight: 500;
        font-size: 16px;
      }
      :global(.history-dropdown-icon) {
        color: ${Colors.elm};
        margin-right: 10px;
      }
      :global(.history-dropdown) {
        margin-top: 1.5em;
        margin-bottom: 1.5em;
        cursor: pointer;
      }
    `}</style>
  </>
);

const HistoryDropDownButton = ({
  visible,
  changeDropdown,
  buttonText = 'View History',
}: {
  visible: boolean;
  changeDropdown: (value: boolean) => void;
  buttonText?: string;
}) => (
  <>
    <Button
      className="dropdown-button"
      onClick={() => changeDropdown(!visible)}
    >
      <span className="dropdown-button-text">{buttonText}</span>
      <Icon icon={visible ? 'chevronUp' : 'chevronDown'} kind="regular" />
    </Button>
    <style jsx>{`
      :global(.dropdown-button) {
        margin: 1em 0;
      }
      .dropdown-button-text {
        margin-right: 8px;
      }
    `}</style>
  </>
);

HistoryDropDown.defaultProps = {
  hrVisible: true,
};
